import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Clock } from "lucide-react";

const WARN_BEFORE_MS = 10 * 60 * 1000;

function tokenExpiryMs(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export const SessionExpiryWarning = ({ token, onExpired }) => {
  const [minutesLeft, setMinutesLeft] = useState(null);

  useEffect(() => {
    if (!token) return;
    const exp = tokenExpiryMs(token);
    if (!exp) return;
    let id;
    const check = () => {
      const ms = exp - Date.now();
      if (ms <= 0) {
        clearInterval(id);
        toast.error("Tu sesión ha caducado. Vuelve a iniciar sesión.");
        onExpired();
        return;
      }
      setMinutesLeft(ms <= WARN_BEFORE_MS ? Math.max(1, Math.ceil(ms / 60000)) : null);
    };
    check();
    id = setInterval(check, 30000);
    return () => clearInterval(id);
  }, [token, onExpired]);

  if (minutesLeft == null) return null;

  return (
    <div
      data-testid="session-expiry-warning"
      className="bg-amber-100 border-b border-amber-300 text-amber-900"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-2.5 flex items-center gap-2 text-sm font-semibold">
        <Clock size={16} className="shrink-0" />
        <span>
          Tu sesión caducará en aproximadamente {minutesLeft} {minutesLeft === 1 ? "minuto" : "minutos"}.
          Guarda tu trabajo; después tendrás que volver a iniciar sesión.
        </span>
      </div>
    </div>
  );
};
